import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Tooltip, IconButton, Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { Delete, Save } from '@mui/icons-material';
import { FakeText } from '@totalsoft/rocket-ui';
import EngineScoringKnockoutCriteriaListItemComponent from './EngineScoringKnockoutCriteriaListItemComponent';
import EngineScoringKnockoutCriteriaSummaryComponent from './EngineScoringKnockoutCriteriaListSummaryComponent';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getErrors, isValid } from '@totalsoft/pure-validations-react';

const EngineScoringKnockoutCriteriaListComponent = ({
  knockoutCriteria,
  dictionaryKnockoutCriteria,
  onSave,
  dispatch,
  isReadOnly,
  validation,
  loading
}) => {
  const { t } = useTranslation();

  const onDeleteKnockoutCriterion = (criterion, index) => {
    if (window.confirm(t('EngineScoring.EngineClassifications.Delete'))) {
      onSave('OnDeleteEngineScoringKnockoutCriteria', criterion, index);
    }
  };

  const onSaveKnockoutCriterion = (criterion, index) => {
    onSave('OnSaveKnockoutCriterion', { criterion, index });
  };

  const onExpandChange = (isExpanded, index) => {
    dispatch({ type: 'OnKnockoutCriterionExpanded', index, isExpanded });
  };

  return loading ? (
    <FakeText lines={10} />
  ) : (
    <>
      {knockoutCriteria.map((item, idx) => {
        return (
          <Grid key={idx} item sx={{ marginBottom: '35px!important' }} xs={12}>
            <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandChange(isExpanded, idx)}>
              <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
                {item.isExpanded ? (
                  <>
                    <Typography variant='h6'> {item.name}</Typography>
                    <Grid item xs={12} sm={12} onClick={event => event.stopPropagation()}>
                      <Grid container spacing={1} justifyContent='flex-end'>
                        <Grid item>
                          <Tooltip title={t('Tooltips.Save')}>
                            <span>
                              <IconButton
                                color='primary'
                                onClick={() => onSaveKnockoutCriterion(item, idx)}
                                disabled={
                                  !item.changed ||
                                  isReadOnly ||
                                  (validation |> getErrors) !== '' ||
                                  !(validation[idx] |> isValid) ||
                                  item.saving
                                }
                              >
                                <Save />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Grid>
                        <Grid item>
                          <Tooltip title={t('Tooltips.Delete')}>
                            <IconButton color='primary' onClick={() => onDeleteKnockoutCriterion(item, idx)} disabled={isReadOnly}>
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <span style={{ width: '100%' }}>
                    <EngineScoringKnockoutCriteriaSummaryComponent
                      criterion={item}
                      dictionaryKnockoutCriteria={dictionaryKnockoutCriteria}
                      isReadOnly={isReadOnly}
                    />
                  </span>
                )}
              </AccordionSummary>
              <AccordionDetails>
                <EngineScoringKnockoutCriteriaListItemComponent
                  criterion={item}
                  index={idx}
                  dispatch={dispatch}
                  dictionaryKnockoutCriteria={dictionaryKnockoutCriteria}
                  isReadOnly={isReadOnly}
                  collectionValidation={validation}
                />
              </AccordionDetails>
            </Accordion>
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <Typography color='error'>{validation |> getErrors}</Typography>
      </Grid>
    </>
  );
};

EngineScoringKnockoutCriteriaListComponent.propTypes = {
  knockoutCriteria: PropTypes.array.isRequired,
  dictionaryKnockoutCriteria: PropTypes.array.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  expanded: PropTypes.string
};

export default EngineScoringKnockoutCriteriaListComponent;
